import { createStore } from 'vuex';

export default createStore({
  state: {
    user: null,
  },

  mutations: {
    setUser(state, user) {
      state.user = user;
    },
  },

  actions: {
    login({ commit }, user) {
      commit('setUser', user);
    },
    
    logout({ commit }) {
      commit('setUser', null);
    },
  },

  getters: {
    isAuthenticated(state) {
      return !!state.user;
    },
  },
});